var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOn1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11172_7769",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11172_7769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 16.2614C11.6303 14.8019 12.8778 13.402 13.7427 12.0618C14.6076 10.7215 15.04 9.5476 15.04 8.5401C15.04 7.02094 14.5574 5.77205 13.5921 4.79344C12.6268 3.81482 11.4294 3.32552 9.99999 3.32552C8.57055 3.32552 7.37319 3.81482 6.40791 4.79344C5.44263 5.77205 4.95999 7.02094 4.95999 8.5401C4.95999 9.5476 5.39242 10.7215 6.25728 12.0618C7.12214 13.402 8.36971 14.8019 9.99999 16.2614ZM9.99999 17.4503C9.83763 17.4503 9.67527 17.4223 9.51291 17.3664C9.35041 17.3102 9.20346 17.2234 9.07208 17.1059C8.3243 16.4168 7.62451 15.707 6.9727 14.9768C6.32103 14.2466 5.75458 13.5167 5.27332 12.787C4.79194 12.0573 4.41103 11.334 4.13062 10.6172C3.8502 9.90024 3.70999 9.20788 3.70999 8.5401C3.70999 6.61705 4.33201 5.06017 5.57603 3.86948C6.8202 2.67878 8.29485 2.08344 9.99999 2.08344C11.7051 2.08344 13.1798 2.67878 14.424 3.86948C15.668 5.06017 16.29 6.61705 16.29 8.5401C16.29 9.20788 16.1498 9.89885 15.8694 10.613C15.589 11.3273 15.2094 12.0507 14.7308 12.783C14.2521 13.5154 13.6869 14.2453 13.0352 14.9728C12.3835 15.7005 11.6837 16.4088 10.9358 17.0978C10.8064 17.2153 10.6592 17.3034 10.4944 17.3622C10.3296 17.4209 10.1649 17.4503 9.99999 17.4503ZM10.0015 9.88781C10.416 9.88781 10.7705 9.74017 11.0648 9.44489C11.3592 9.14962 11.5065 8.79469 11.5065 8.3801C11.5065 7.96552 11.3588 7.61101 11.0635 7.31656C10.7683 7.02226 10.4133 6.8751 9.99853 6.8751C9.58395 6.8751 9.22951 7.02274 8.9352 7.31802C8.64076 7.6133 8.49353 7.9683 8.49353 8.38302C8.49353 8.7976 8.64117 9.15205 8.93645 9.44635C9.23173 9.74066 9.58673 9.88781 10.0015 9.88781Z",
    fill: "#475467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn1);
export default __webpack_public_path__ + "static/media/location_on-1.2efe66818d1af178db5871eb1c84e882.svg";
export { ForwardRef as ReactComponent };